import { useI18n } from '~/stores/i18n';

export class UrlHelper {
  static getBaseUrl(withLangCode = true) {
    if (withLangCode) {
      const langCode = useI18n.getState().lang;
      return `${URL_HOST}${langCode === 'en' ? '' : '/' + langCode}`;
    }
    return URL_HOST;
  }

  static url(path, withLangCode = true) {
    return UrlHelper.getBaseUrl(withLangCode) + path;
  }

  static localizedLink(to) {
    const langCode = useI18n.getState().lang;
    const toWithSlash = to.startsWith('/') ? to : `/${to}`;
    const localizedTo = `${
      langCode !== 'en' && !to.startsWith(`/${langCode}/`) ? `/${langCode}` : ''
    }${toWithSlash}`;
    return localizedTo;
  }

  static getLocationSearchUrl(country, city) {
    const formattedCountry = country.toLowerCase().split(' ').join('-');
    const formattedCity = city.toLowerCase().split(' ').join('-');
    return `/experiences/${formattedCountry}/${formattedCity}/`;
  }
}
